import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image
} from '@react-pdf/renderer';
// @ts-ignore
const logoCentralis = require('../../assets/logo/logo-centralis-gris.png');
// @ts-ignore
const bandeauCentralis = require('../../assets/logo/bandeau-centralis.png');
// Ajoute un QR code si besoin

const styles = StyleSheet.create({
  page: { padding: 0, fontSize: 12, fontFamily: 'Helvetica', backgroundColor: '#FFFDFC' },
  bandeau: { width: '100%', height: 40 },
  header: { flexDirection: 'row', alignItems: 'center', padding: 24, paddingBottom: 0 },
  logo: { width: 100, marginRight: 16 },
  enteteSociete: { fontSize: 8, color: '#555', flex: 1 },
  titreBloc: {
    border: '1 solid #222',
    margin: 24,
    marginBottom: 0,
    padding: 12,
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  titre: { fontSize: 18, fontWeight: 'bold', marginBottom: 4 },
  sousTitre: { fontSize: 12, marginBottom: 4 },
  qr: { width: 70, height: 70, marginLeft: 24 },
  titreBlocLeft: { flex: 1 },
  section: { margin: 24, marginTop: 16 },
  sectionTitle: { fontSize: 13, fontWeight: 'bold', marginBottom: 8, color: '#2C3948' },
  label: { fontWeight: 'bold' },
  value: { marginLeft: 4 },
  highlight: { backgroundColor: '#FFF200' },
  table: { display: 'table', width: 'auto', marginVertical: 8 },
  tableRow: { flexDirection: 'row' },
  tableCellHeader: { flex: 1, fontWeight: 'bold', backgroundColor: '#eee', padding: 4, fontSize: 11 },
  tableCell: { flex: 1, padding: 4, borderBottom: '1 solid #ccc', fontSize: 11 },
  signature: { backgroundColor: '#FFF200', color: '#222', fontWeight: 'bold', fontSize: 14, marginTop: 12, marginBottom: 12, textAlign: 'center' },
  info: { fontSize: 10, color: '#555', marginTop: 8 },
});

const SuiviCommandePDF = ({ commande }: { commande: any }) => {
  const form = commande.formulaire || commande;
  // Génère l'URL du QR code pointant vers la page des documents du contrat
  const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=https://centralis.site/contrat/${commande.numeroDeCommande || commande.id}/documents`;

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Bandeau Centralis */}
        <View style={{ flexDirection: 'row', alignItems: 'center', backgroundColor: '#FFFDFC' }}>
          <Image src={bandeauCentralis} />
        </View>
        {/* Bloc titre */}
        <View style={styles.titreBloc}>
          <View style={styles.titreBlocLeft}>
            <Text style={styles.titre}>MARCHE SUBSEQUENT</Text>
            <Text style={styles.sousTitre}>N° {commande.numeroDeCommande || 'XX'}</Text>
            <Text style={styles.sousTitre}>
              Date de la commande (consultation) : <Text style={styles.highlight}>{form.dateConsultation || '-'}</Text>
            </Text>
            <Text style={styles.sousTitre}>
              Lot technique : <Text style={styles.highlight}>{commande.lotTechnique}</Text>
            </Text>
            <Text style={styles.sousTitre}>
              Lot géographique : <Text style={styles.highlight}>{commande.lotGeographique}</Text>
            </Text>
            <Text style={styles.sousTitre}>
              N° de référence interne : <Text style={styles.highlight}>{form.referenceInterne || '-'}</Text>
            </Text>
          </View>
          <View style={{ alignItems: 'center', justifyContent: 'center' }}>
            <Image src={qrCodeUrl} style={styles.qr} />
            <Text style={{ fontSize: 8, marginTop: 4 }}>Pièces du marché</Text>
          </View>
        </View>
        {/* Acheteur */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>ACHETEUR</Text>
          <Text>
            <Text style={styles.label}>Organisme :</Text> {commande.client?.organisme}
          </Text>
          <Text>
            <Text style={styles.label}>Adresse postale :</Text> {commande.client?.adresse}
          </Text>
          <Text>
            <Text style={styles.label}>Nom du contact :</Text> {commande.client?.contact}
          </Text>
          <Text>
            <Text style={styles.label}>Mail :</Text> {commande.client?.email}
          </Text>
          <Text>
            <Text style={styles.label}>Téléphone :</Text> {commande.client?.telephone}
          </Text>
        </View>
        {/* Prestataire titulaire */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>PRESTATAIRE TITULAIRE</Text>
          <Text>
            <Text style={styles.label}>Organisme :</Text> {commande.prestataires?.[0]?.organisme}
          </Text>
          <Text>
            <Text style={styles.label}>Adresse postale :</Text> {commande.prestataires?.[0]?.adresse}
          </Text>
          <Text>
            <Text style={styles.label}>Nom du contact :</Text> {commande.prestataires?.[0]?.contact}
          </Text>
          <Text>
            <Text style={styles.label}>Mail :</Text> {commande.prestataires?.[0]?.email}
          </Text>
          <Text>
            <Text style={styles.label}>Téléphone :</Text> {commande.prestataires?.[0]?.telephone}
          </Text>
        </View>
        {/* Objet du marché */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>OBJET DU MARCHE</Text>
          <Text>
            <Text style={styles.label}>Nom de l’opération :</Text>
            <Text style={styles.highlight}> {form.nomOperation}</Text>
          </Text>
          <Text>
            <Text style={styles.label}>Adresse d’intervention :</Text>
            <Text style={styles.highlight}> {form.adresse}, {form.codePostal} {form.ville}</Text>
          </Text>
          <Text>
            <Text style={styles.label}>Cahier des charges en complément du CCTP :</Text>
            <Text style={styles.highlight}> {form.definitionBesoin}</Text>
          </Text>
          <Text>
            <Text style={styles.label}>Maîtrise d’œuvre désignée :</Text>
            <Text style={styles.highlight}> {form.coordonneesMaitrise || form.maitriseOeuvre || '-'}</Text>
          </Text>
        </View>
        {/* Offre du prestataire */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>OFFRE DU PRESTATAIRE</Text>
          <Text>
            <Text style={styles.label}>Réponse technique au cahier des charges :</Text>
            <Text style={styles.highlight}> {commande.reponseTechnique || '-'}</Text>
          </Text>
        </View>
        {/* Détail financier */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>DETAIL FINANCIER</Text>
          <View style={styles.table}>
            <View style={styles.tableRow}>
              <Text style={styles.tableCellHeader}>N°</Text>
              <Text style={styles.tableCellHeader}>Descriptif</Text>
              <Text style={styles.tableCellHeader}>Prix HT Forfaitaire</Text>
            </View>
            {(commande.articles || []).map((a: any, idx: number) => (
              <View style={styles.tableRow} key={idx}>
                <Text style={styles.tableCell}>{a.numero}</Text>
                <Text style={styles.tableCell}>{a.prestation}</Text>
                <Text style={styles.tableCell}>{a.totalHT ? `${a.totalHT.toLocaleString()} €` : '0 €'}</Text>
              </View>
            ))}
          </View>
          <Text style={{ marginTop: 8, fontWeight: 'bold' }}>
            TOTAL HT = <Text style={styles.highlight}>
              {(commande.articles || []).reduce((sum: number, a: any) => sum + (a.totalHT || 0), 0).toLocaleString()} €
            </Text>
          </Text>
        </View>
        {/* Signatures électroniques */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>SIGNATURES ELECTRONIQUES DES PARTIES</Text>
          <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginTop: 16 }}>
            <View style={{ width: '45%' }}>
              <Text style={{ fontWeight: 'bold', marginBottom: 4 }}>LE PRESTATAIRE TITULAIRE</Text>
              <Text style={{ fontSize: 10, marginBottom: 8 }}>Signé électroniquement le XX/XX/XXXX à XXhXX par M. XXXXXX</Text>
              <Text style={[styles.signature, styles.highlight]}>signature</Text>
            </View>
            <View style={{ width: '45%' }}>
              <Text style={{ fontWeight: 'bold', marginBottom: 4 }}>L’ACHETEUR</Text>
              <Text style={{ fontSize: 10, marginBottom: 8 }}>Signé électroniquement le XX/XX/XXXX à XXhXX par M. XXXXXX</Text>
              <Text style={[styles.signature, styles.highlight]}>signature</Text>
            </View>
          </View>
        </View>
        {/* Suivi du marché */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>SUIVI DU MARCHE SUBSEQUENT</Text>
          <Text>
            <Text style={styles.label}>Création du marché :</Text>
            <Text style={styles.highlight}> XX/XX/XXXX à XXhXX par M. XXXXXX</Text>
          </Text>
          {/* ... Ajoute ici les autres étapes du suivi comme sur ton modèle ... */}
        </View>
        {/* Notification */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>NOTIFICATION</Text>
          <Text>
            Je soussigné M. <Text style={styles.highlight}>XXXXX</Text>, représentant de la société <Text style={styles.highlight}>XXXXXX</Text>, accuse bonne réception de la notification du marché subséquent N°<Text style={styles.highlight}>XXXXXX</Text> à la date du <Text style={styles.highlight}>XX/XX/XXXX</Text> dont la durée prévisionnelle d’exécution est de <Text style={styles.highlight}>XX jours</Text> à compter du démarrage d’exécution le <Text style={styles.highlight}>XX/XX/XXXX</Text>.
          </Text>
          <Text style={[styles.signature, styles.highlight]}>signature</Text>
        </View>
        {/* Mentions */}
        <View style={styles.section}>
          <Text style={styles.info}>
            Aucune mention manuscrite supplémentaire (ou rature) sur le document n’est recevable. Aucune modification ou ajout ne peut être effectué, même sous la forme numérique.
          </Text>
        </View>
      </Page>
    </Document>
  );
};

export default SuiviCommandePDF;